export class ConfinedSpacePrepHazard {
    id = ''
    permitId = ''
    sortOrder = 0
    hazard = ''
    preparationIsolation = ''
    dateCompleted: Date | string | null = null
}

export class ConfinedSpacePeriodicTest {
    id = ''
    permitId = ''
    sortOrder = 0
    testedOn: Date | string | null = null
    oxygenO2 = ''
    flammableLel = ''
    combustibleCo2 = ''
    toxicH2s = ''
}

export class ConfinedSpaceEntryPermit {
    id!: string
    indexId!: number
    issuedDateTime?: Date | string | null
    expirationDateTime?: Date | string | null
    job?: string | null
    address?: string | null
    jobSiteSpaceId?: string | null
    jobSupervisor?: string | null
    workToBePerformed?: string | null
    checklistComplete = false
    entrantNames?: string | null
    entrantHasReceivedTraining = false
    attendantPersonnel?: string | null
    attendantHasReceivedTraining = false
    supervisorsName?: string | null
    supervisorHasReceivedTraining = false
    initialOxygenLevel?: string | null
    initialOxygenSafe = false
    initialFlammableLevel?: string | null
    initialFlammableSafe = false
    initialDustLevel?: string | null
    initialDustSafe = false
    initialToxicLevel?: string | null
    initialToxicSafe = false
    initialOtherConditionsSafe = false
    initialUnsafeDescription?: string | null
    initialTesterName?: string | null
    initialTestedOn?: Date | string | null
    initialTesterSignature?: string | null
    initialTesterSignedOn?: Date | string | null
    mechanicalVentilation = false
    naturalVentilationOnly = false
    ventilationMalfunctionDetection?: string | null
    postOxygenLevel?: string | null
    postOxygenSafe = false
    postFlammableLevel?: string | null
    postFlammableSafe = false
    postDustLevel?: string | null
    postDustSafe = false
    postToxicLevel?: string | null
    postToxicSafe = false
    postOtherConditionsSafe = false
    postUnsafeDescription?: string | null
    postTesterName?: string | null
    postTestedOn?: Date | string | null
    postTesterSignature?: string | null
    postTesterSignedOn?: Date | string | null
    communicationProcedures?: string | null
    rescueTeamContactProcedure?: string | null
    procedureReviewedBy?: string | null
    procedureReviewedOn?: Date | string | null
    equipmentFourGasMonitor = false
    equipmentVentilation = false
    equipmentHarnessLifelines = false
    equipmentRetrievalDevice = false
    equipmentCommunications = false
    equipmentAccess = false
    equipmentProtectiveClothing = false
    equipmentElectricListed = false
    preparerSignature?: string | null
    preparerSignedOn?: Date | string | null
    entrySupervisorSignature?: string | null
    entrySupervisorPrintedName?: string | null
    entrySupervisorSignedOn?: Date | string | null
    entrantSignature?: string | null
    entrantPrintedName?: string | null
    entrantSignedOn?: Date | string | null
    attendantSignature?: string | null
    attendantPrintedName?: string | null
    attendantSignedOn?: Date | string | null
    createdOn?: Date | string | null
    createdByUserId?: string | null
    archived!: boolean

    prepHazards: ConfinedSpacePrepHazard[] = []
    periodicTests: ConfinedSpacePeriodicTest[] = []

    jobDisplay?: string | null

    static createNew(): ConfinedSpaceEntryPermit {
        const item = new ConfinedSpaceEntryPermit()
        item.id = crypto.randomUUID()
        return item
    }

    protected $setProperties(source: any): void {
        source.prepHazards = source.prepHazards ?? []
        source.periodicTests = source.periodicTests ?? []
        source.jobDisplay = source.jobDisplay ?? source.job ?? ''
    }
}
